import { render, staticRenderFns } from "./ClothesPage.vue?vue&type=template&id=6b526706&scoped=true&"
import script from "./ClothesPage.vue?vue&type=script&lang=js&"
export * from "./ClothesPage.vue?vue&type=script&lang=js&"
import style0 from "./ClothesPage.vue?vue&type=style&index=0&id=6b526706&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b526706",
  null
  
)

export default component.exports